import { render, staticRenderFns } from "./CompressAltIcon.vue?vue&type=template&id=38c66a0c&"
import script from "./CompressAltIcon.vue?vue&type=script&lang=js&"
export * from "./CompressAltIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports